import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/best-cats-for-speed";

const { Content } = Layout;
// const convertBasedOnLevel = require("../../table/calc-stats");

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Speed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Best Cats for Speed | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "285-3",
        name: "Bullet Train Cat",
        number: "285-3",
        form: "True",
        rarity: "Super Rare",
        level: 1,
        health: 3000,
        damage: 4375,
        range: 140,
        kb: 1,
        speed: 85,
        dps: 652,
        target: "Single",
        tba: "6.70",
        anim: "0.03",
        spawn: "19.53",
        cost: 750,
        ability:
          "u1General Abilitiesu2: b1Extra moneyb2 (2x money gained from defeated enemies)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "582-1",
        name: "Stone Cat",
        number: "582-1",
        form: "Normal",
        rarity: "Rare",
        level: 1,
        health: 50000,
        damage: 700,
        range: 140,
        kb: 1,
        speed: 84,
        dps: 512,
        target: "Single",
        tba: "1.37",
        anim: "0.03",
        spawn: "5.20",
        cost: 360,
        ability:
          "u1General Abilitiesu2: b1Attack Onceb2 (Attacks a single time, then disappears from the battlefield)\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "072-3",
        name: "Immortal Yukimura",
        number: "072-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4250,
        damage: 6188,
        range: 170,
        kb: 5,
        speed: 75,
        dps: 1355,
        target: "Area",
        tba: "4.57",
        anim: "0.03",
        spawn: "51.53",
        cost: 3075,
        ability:
          "u1Against blacku2: b1Massive Damageb2 (inflicts 3.0x damage) \nu1General Abilitiesu2: b1Multi-hit attackb2 (Attacks twice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "029-1",
        name: "Capsule Cat",
        number: "029-1",
        form: "Normal",
        rarity: "Special",
        level: 1,
        health: 2,
        damage: 750,
        range: 140,
        kb: 1,
        speed: 70,
        dps: 102,
        target: "Single",
        tba: "7.40",
        anim: "0.07",
        spawn: "11.53",
        cost: 666,
        ability: " ",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "096-3",
        name: "Manic Lion Cat",
        number: "096-3",
        form: "True",
        rarity: "Super Rare",
        level: 1,
        health: 4500,
        damage: 118,
        range: 140,
        kb: 5,
        speed: 66,
        dps: 352,
        target: "Area",
        tba: "0.33",
        anim: "0.20",
        spawn: "4.53",
        cost: 750,
        ability: " ",
        iscrazed: true,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "572-1",
        name: "E. Honda",
        number: "572-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 18750,
        damage: 1875,
        range: 230,
        kb: 3,
        speed: 63,
        dps: 618,
        target: "Area",
        tba: "3.03",
        anim: "0.10",
        spawn: "91.53",
        cost: 3675,
        ability:
          "u1Against angelu2: b1Resistantb2 (only takes 0.25x damage) b1Knockbackb2 (100% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "026-3",
        name: "Awakened Bahamut Cat",
        number: "026-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 3750,
        damage: 13750,
        range: 200,
        kb: 6,
        speed: 60,
        dps: 4435,
        target: "Area",
        tba: "3.10",
        anim: "0.17",
        spawn: "98.20",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "508-2",
        name: "Supercat",
        number: "508-2",
        form: "Evolved",
        rarity: "Rare",
        level: 1,
        health: 4500,
        damage: 500,
        range: 140,
        kb: 10,
        speed: 60,
        dps: 100,
        target: "Single",
        tba: "5.03",
        anim: "0.03",
        spawn: "21.53",
        cost: 720,
        ability:
          "u1Against whiteu2: b1Weakenb2 (100% chance to weaken by 50% for 6.67s) \nu1General Abilitiesu2: b1Wave Shieldb2 (Protects units behind them from shockwaves)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "516-1",
        name: "Blanka",
        number: "516-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 6000,
        damage: 3750,
        range: 150,
        kb: 8,
        speed: 55,
        dps: 1210,
        target: "Area",
        tba: "3.10",
        anim: "0.17",
        spawn: "58.20",
        cost: 3300,
        ability:
          "u1Against alienu2: b1Massive Damageb2 (inflicts 3.0x damage) \r\nu1General Abilitiesu2: b1Barrier Breakerb2 (100% chance of breaking enemy barriers) b1Omni Strikeb2 (Effective range -100~300)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "136-3",
        name: "Ultima Galaxy Cosmo",
        number: "136-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4000,
        damage: 8375,
        range: 850,
        kb: 4,
        speed: 54,
        dps: 405,
        target: "Area",
        tba: "20.67",
        anim: "10.70",
        spawn: "131.53",
        cost: 5850,
        ability:
          "u1Against floating, angelu2: b1Freezeb2 (100% chance to freeze for 5.0s) b1Knockbackb2 (100% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Best Cats
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <span>
                    <VenatusAdWithPlaceholder
                      placementId={VENATUS_DESKTOP_LEADERBOARD}
                    />
                  </span>
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_INCONTENT}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Best Cats for Speed
                </h2>
                <p></p>
                <div>
                  What are the best cats in the Battle Cats with the highest
                  speed? Which ones can help you clear stages the fastest, and
                  are the best choices for timed stages?
                </div>
                <p></p>
                <div>
                  Comparing the stats for the top 10 cats gives us the list
                  below, with the fastest at the top.
                </div>
                <p></p>
                <i>Last updated: 22 March 2021</i>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Speed"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Speed"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  He has reached the edge of the universe and seen the truth.
                  Area attacks have 100% chance of knockback & freeze vs
                  Floating/Angels.
                  <p></p>
                  <b>Pros: </b>Also on the{" "}
                  <Link to={"/best-cats-for-range"}>Best Cats for Range</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Its fast speed may work against it, as it has a
                  tendency to run into the enemy frontline. Avoid using the Cat
                  Cannon whenever it's deployed.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[9].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ultima Galaxy Cosmo"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Joining the fight from Street Fighter V AE! Gentle defender of
                  the Amazon forests. Massive Omnistrike damage vs Aliens
                  <p></p>
                  <b>Pros: </b>Able to deal a good amount of damage, especially
                  against Aliens, due to its high knockback count.
                  <p></p>
                  <b>Cons: </b>Less useful against fast attackers who may keep
                  disrupting its attack.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[8].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Blanka")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Grew Macho thanks to his nervous eating habit. Practices
                  singing in the park when no one's around. Weaken Traitless,
                  nullfies Wave Attacks
                  <p></p>
                  <b>Pros: </b>High number of knockbacks with a decent health
                  means it has a good chance of weakening strong enemies for
                  quite a while, sometimes even till the next Supercat can be
                  spawned.
                  <p></p>
                  <b>Cons: </b>Its Wave Shield ability is often nullified by its
                  short range and high knockbacks, leaving cats behind it
                  unprotected.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[7].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Supercat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  They say the power to obliterate Earth is already his. Freed
                  of the suit which shackled his power, his power and speed is
                  unmatched (Area Attack)
                  <p></p>
                  <b>Pros: </b>A must-have for 4-star stages and for speed runs,
                  especially with its evolved{" "}
                  <Link to={"/catinfo/026/Crazed%20Bahamut%20Cat"}>
                    Crazed Bahamut Cat
                  </Link>{" "}
                  form that has a vastly improved range, albeit longer time
                  between attacks. Also on the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Tends to rush into the enemy frontline with its
                  short range, so this precious attacker must be shielded well.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[6].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Awakened Bahamut Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Joining the fight from Street Fighter V! The world will know
                  the majestic art of Sumo! Tough vs Angels, with 100%
                  Knockback! (Area Atk)
                  <p></p>
                  <b>Pros: </b>Good health, especially against Angels. Able to
                  hold back the enemy frontline for a good amount of time.
                  <p></p>
                  <b>Cons: </b>Has a bad habit of knocking back enemies, which
                  causes attacks against them to miss. It's also a collab cat,
                  so it won't be too easy to get him, plus there are better cats
                  to go for in that collab.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[5].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "E. Honda"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  An excellent, agile character. Though Manic, his magnificent
                  mane somehow grants him godspeed (Area Atk)
                  <p></p>
                  <b>Pros: </b>Perfect for clearing peons or to cheese stages.
                  In more desperate situations, can also be used to stall the
                  enemies.
                  <p></p>
                  <b>Cons: </b>Middling damage dealer with its weak health and
                  high number of knockbacks. Unlikely to see much use in the
                  later stages of Stories of Legend or Uncanny Legends.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[4].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Manic Lion Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  An experimental weapon: one speedy Cat, protected by
                  state-of-the-art gashapon plastic. Packs a punch, but
                  definitely can't take one.
                  <p></p>
                  <b>Pros: </b>Great for stalling against enemies with a long
                  attack animation, like Dark Emperor Nyandam.
                  <p></p>
                  <b>Cons: </b>Real ominous cost — and also a much weaker
                  version of{" "}
                  <Link to={"/catinfo/285/Bullet%20Train%20Cat"}>
                    Bullet Train Cat
                  </Link>
                  .
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[3].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Capsule Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Crimson wings carry this wargod through the front lines,
                  tearing them apart without mercy! Deals massive damage to
                  Black enemies.
                  <p></p>
                  <b>Pros: </b>Fast, reliable damage dealer, especially if
                  shielded well. Decent spawn rate too, so may be a real
                  lifesaver against strong bosses.
                  <p></p>
                  <b>Cons: </b>Relatively poor range and health, so typically
                  doesn't last long.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[2].damage}  */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Immortal Yukimura"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A mineral-based lifeform recovered by
                  GAMATOTO from deep beneath the earth. Finally made useful
                  after eight years of research. Attacks exactly once.
                  <p></p>
                  <b>Pros: </b>Also in the{" "}
                  <Link to={"/best-cats-for-health"}>Best Cats for Health</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>An ultimate barrier for only 1+ seconds, while
                  its attack animation runs.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[1].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Stone Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Can take a maximum of 2222 passengers on a round-the-world
                  journey at 20,000,000 km/h Extra money when defeating enemies!
                  <p></p>
                  <b>Pros: </b>A great money-maker who can often 1-hit K.O. Doge
                  Dark. Great for farming in those cash-strapped stages, except
                  for the Arena of Honor.
                  <p></p>
                  <b>Cons: </b>Only 1 knockback, so may end up being 1-hit KO-ed
                  instead by a strong enemy boss without raking in the cash.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Bullet Train Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 10 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="6015153906"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Speed;

Speed.propTypes = {
  applyViewportChange: PropTypes.number,
};

Speed.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/bestcats/Speed.js